export default {
  // timestamp 轉 dateTime
  toDateTime(timestamp) {
    // 轉成毫秒
    if (timestamp.toString().length <= 10) timestamp *= 1000;
    return new Date(timestamp);
  },
  // 格式化 date 可指定連接標點符號、是否顯示時間
  formatDate(time, apostrophe = '/', hasTime = false) {
    const vm = this;
    const stringBuilder = [];
    stringBuilder.push(
      time.getFullYear(),
      vm.padZero(time.getMonth() + 1, 2),
      vm.padZero(time.getDate(), 2),
    );
    if (hasTime) {
      return `${stringBuilder.join(apostrophe)} ${vm.padZero(time.getHours(), 2)}:${vm.padZero(time.getMinutes(), 2)}`;
    }
    return stringBuilder.join(apostrophe);
  },
  // 將數字補零到固定長度
  padZero(number, length) {
    return number.toString().padStart(length, '0');
  },
  // 將台灣時間"yyyy/MM/dd hh:mm:ss"字串轉為Date物件
  parseTaiwanDateTime(dateTimeString) {
    dateTimeString = dateTimeString.replace(/\//igm, '-');
    const parts = dateTimeString.split(' ');
    return new Date(`${parts[0]}T${parts[1]}+08:00`);
  },
  // 將Date物件轉為台灣時間"yyyy/MM/dd hh:mm:ss"字串
  formatTaiwanDateTime(date) {
    const twDate = new Date(date.valueOf() + 1000 * 60 * 60 * 8);
    return `${twDate.getUTCFullYear()}/${this.padZero(twDate.getUTCMonth() + 1, 2)}/${this.padZero(twDate.getUTCDate(), 2)} ${this.padZero(twDate.getUTCHours(), 2)}:${this.padZero(twDate.getUTCMinutes(), 2)}`;
  },
};
